import _ from 'underscore';
import React from 'react';
import {
  getSummaryCardModel,
} from '@bingads-webui-campaign/recommendation-core';
import { SummaryCard, SummaryFooter } from '@bingads-webui-campaign-react/recommendation-summary-view';

import { TipItem } from './tip-item';
import { isTip, ITip, TActiveItem } from '../types';

// @ts-ignore
const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

function combineText(textPart1, textPart2) {
  if (!textPart1 || !textPart2) {
    return '';
  }

  // If text1 does not end with any of separators [. ? !], use a period and space between text1 and text2 while stitching.
  // If text1 ends with one of those separators, use only a space.
  if ('.?!'.indexOf(textPart1.slice(-1)) > -1) {
    return `${textPart1} ${textPart2}`;
  }
  return `${textPart1}. ${textPart2}`;
}

export const CarouselItem = ({
  item,
  i18n,
  i18nErrors,
  serverContext,
  permissions,
  scope,
  isMCC,
  currentActivity,
  logOpportunityEvent,
  preferencesService,
  locationMap,
  overallOptimizationScoreBar,
  viewRecommendation,
  legacyConfig,
  walkme,
  jsdata,
  instrumentationConstants,
  instrumentationLegacy,
  logSlideDisplay,
  adDisplayUrlService,
  removeTipLocally,
} : {
  item: TActiveItem;
  i18n: {
    getString: (key: string) => string;
  };
  i18nErrors: object;
  serverContext: any;
  permissions: any;
  scope: {
    levelAt: string;
  };
  isMCC: boolean;
  currentActivity: any;
  logOpportunityEvent: any;
  preferencesService: any;
  locationMap: any;
  overallOptimizationScoreBar: object;
  viewRecommendation: Function;
  legacyConfig: any;
  walkme: any;
  jsdata: any;
  instrumentationConstants: any,
  instrumentationLegacy: any,
  logSlideDisplay: ({ reason }: { reason: string }) => void;
  adDisplayUrlService: any;
  removeTipLocally: (tipId: string) => void;
}) => {
  if (!isTip(item)) {
    const summaryCardModel = getSummaryCardModel(_.extend({}, item, {
      i18n: legacyI18n,
      newI18n: i18n,
      errI18n: i18nErrors,
      currency: serverContext.CurrentAccount.CurrencyCode,
      scope: scope.levelAt,
      permissions,
      combineText,
      adDisplayUrlService,
      isMCC,
      currentActivity,
    }));

    const summaryCardOptions = _.extend({
      key: item.type,
      recommendationsCount: item.recommendationsCount,
      opportunityCount: item.opportunityCount,
      optimizationScore: item.optimizationScore,
      version: item.version,
      isInlineView: false,
      i18n: legacyI18n,
      newI18n: i18n,
      isMCC,
      permissions,
      preferencesService,
      locationMap,
      applyAllCallback: _.noop,
      scope,
      isOverviewPage: true,
      isOptimizationScoreOn: permissions.dynamic.OptimizationScore && !isMCC,
      overallOptimizationScoreBar,
      category: item.category,
      logOpportunityEvent,
      viewDetails: viewRecommendation,
      currentActivity,
      appConfig: legacyConfig,
    }, summaryCardModel);

    return (
      <>
        <div className="carousel__tip_content">
          <SummaryCard {...summaryCardOptions} />
        </div>
        <div className="summary-footer">
          <div className="summary-footer-content">
            <SummaryFooter {...summaryCardOptions} />
          </div>
        </div>
      </>
    );
  }

  return (
    <TipItem
      item={item as ITip}
      i18n={i18n}
      walkme={walkme}
      jsdata={jsdata}
      instrumentationConstants={instrumentationConstants}
      instrumentationLegacy={instrumentationLegacy}
      logSlideDisplay={logSlideDisplay}
      removeTipLocally={removeTipLocally}
    />
  );
};
